import {
  FAQS,
  FooterLinks,
  AnalyticsHeader,
  NavSubmenuLinks,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  REGISTRATION_TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";

import orderSummaryBg from "public/images/azdbacks/arizona-diamondbacks-baseball-field.jpg";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const BannerImage =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/Screenshot%202024-11-21%20at%209.50.51%E2%80%AFAM.png";

export const azdbacks_upgrades: TTeamConfig = {
  TEAM_SCHEMA: "azdbacks_upgrades",
  TEAM_FULL_NAME: "Arizona Diamondbacks",
  BROWSER_TITLE: "Arizona D-backs Upgrades",
  CLIENT_ID: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#A71930",
    COLORS_SECONDARY: "#E3D4AD",
    IS_INTERCOM_ENABLED: true,
    IS_BALLPARK_APP: true,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_UPCOMING_EVENTS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },
    DEFAULT_APP_ROUTE: routes.landing,
    FOOTER: {
      BACKGROUND_COLOR: "#A71930",
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()} MLB Advanced Media, L.P. All rights reserved`,
    },
    ANALYTICS_HEADER: AnalyticsHeader,
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },

    HIDE_PASSES: true,
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
    },
    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
      ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
        TITLE: () => "Purchase Confirmed!",
        DESCRIPTION: () =>
          "Thank you for your purchase, your tickets are now available. Login to your Ballpark app to view your barcodes.",
      },
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITION />,
    },
  },

  IMAGES: {
    LANDING_PAGE_STATIC_BANNER_URL: BannerImage,
    ORDER_SUMMERY_BACKGROUND_URL: orderSummaryBg.src,
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/AZD-UPDATED.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
